import { render } from "./itemsList.vue?vue&type=template&id=252a6fd2&scoped=true"
import script from "./itemsList.vue?vue&type=script&lang=js"
export * from "./itemsList.vue?vue&type=script&lang=js"

import "./itemsList.vue?vue&type=style&index=0&id=252a6fd2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-252a6fd2"]])

export default __exports__